import { render, staticRenderFns } from "./ChooseMerchant.vue?vue&type=template&id=4eae6920&scoped=true"
import script from "./ChooseMerchant.vue?vue&type=script&lang=js"
export * from "./ChooseMerchant.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4eae6920",
  null
  
)

export default component.exports